import React, { useEffect, useState } from "react";
import "../../assets/styles/components/trueFalse.scss";
import { useDispatch, useSelector } from "react-redux";
import { findValue, updateInput } from "../Input/functions";

export default function TrueFalse(props) {
  const { input, active, setActive } = props;
  const dispatch = useDispatch();
  const activeIndex = useSelector((state) => state).formReducer.activeIndex;
  const formData = useSelector((state) => state).formReducer;
  const defaultValue = active ?? true;

  useEffect(() => {
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex]);

  const updateValue = () => {
    let value = findValue(formData, input.formType, input.name, defaultValue);
    if (input.name === "accountingCode") {
      value = findValue(formData, input.formType, "accountingCodeType", defaultValue);
    }
    setActive(!value);
  };

  const setValue = (value) => {
    setActive(value);
    if (input.name === "accountingCode") {
      updateInput(dispatch, input.formType, "accountingCodeType", value, input.primary);
    } else {
      updateInput(dispatch, input.formType, input.name, value, input.primary);
    }
  };

  return (
    <div className="warp-true-false">
      <p className="value-title-true-false">{props.input.label}</p>
      <label className="switch">
        <input type="checkbox" />
        <span className={active ? "active-slider" : "slider"}></span>
        <div className="true-false">
          {input.options.map((option, index) => {
            return (
              <p
                key={index}
                className={
                  active ? (option.value ? "active" : "active-false") : option.value ? "true" : "false"
                }
                onClick={() => {
                  setValue(option.value);
                }}
              >
                {option.label}
              </p>
            );
          })}
        </div>
      </label>
    </div>
  );
}
